'use strict';

var client = require('@apollo/client');
var React = require('react');
var createFormSubmissionQuery = require('./submission/createFormSubmissionQuery.js');
var parseFormSubmissionErrors = require('./submission/parseFormSubmissionErrors.js');
var nullifyEmptyValues = require('./utils/nullifyEmptyValues.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const genericErrorResponse = (message)=>({
        errors: {
            error: [
                message != null ? message : 'An error occurred.'
            ]
        },
        result: null,
        success: false
    });
const FORMS_ENDPOINT = '/api/forms';
function useFormieSubmit() {
    const client$1 = client.useApolloClient();
    const [isSuccess, setIsSuccess] = React.useState(false);
    const [isError, setIsError] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const [errors, setErrors] = React.useState(null);
    const [result, setResult] = React.useState(null);
    const triggerSubmit = React.useCallback(async (mutationName, formValues, formUid)=>{
        setIsLoading(true);
        setIsError(false);
        setIsSuccess(false);
        setErrors(null);
        setResult(null);
        client$1.setLink(new client.HttpLink({
            uri: `${FORMS_ENDPOINT}/${formUid}/`
        }));
        const mutation = createFormSubmissionQuery({
            mutationName,
            formValues: nullifyEmptyValues(formValues)
        });
        if (!mutation) return genericErrorResponse();
        try {
            await client$1.mutate({
                mutation
            }).then((res)=>{
                const errors = parseFormSubmissionErrors(res);
                var _res_data;
                const maybeResult = (_res_data = res == null ? void 0 : res.data) != null ? _res_data : null;
                const result = !errors && maybeResult ? maybeResult : null;
                const success = !!result;
                setResult(result);
                setIsLoading(false);
                setIsSuccess(success);
                setIsError(!success);
                setErrors(errors);
            }).catch((error)=>{
                let formErrors = {};
                if (client.isApolloError(error)) {
                    const { graphQLErrors = [] } = error;
                    formErrors = graphQLErrors.reduce((results, item)=>{
                        const { message } = item;
                        try {
                            const parsedMessage = JSON.parse(message);
                            return _extends({}, results, parsedMessage);
                        } catch (e) {
                            return _extends({}, results, {
                                error: [
                                    message
                                ]
                            });
                        }
                    }, {});
                } else {
                    formErrors = {
                        error: [
                            'An error occurred.'
                        ]
                    };
                }
                setIsLoading(false);
                setIsError(true);
                setErrors(formErrors);
            });
        } catch (error) {
            console.error(error);
            setIsLoading(false);
            setIsError(true);
            setIsSuccess(false);
            setErrors({
                error: [
                    'An error occurred.'
                ]
            });
        }
        return null;
    }, [
        client$1
    ]);
    return {
        triggerSubmit,
        isSuccess,
        isError,
        isLoading,
        errors,
        result
    };
}

module.exports = useFormieSubmit;
